import { Link } from "react-router-dom";
import { ArrowLeft } from "lucide-react";

export default function NotFound() {
  return (
    <main data-testid="not-found-page" className="min-h-screen bg-navy grain relative flex items-center justify-center px-6">
      <div className="text-center relative z-10">
        <p className="font-display font-black text-[10rem] leading-none text-outline select-none" aria-hidden="true">404</p>
        <h1 className="font-display font-bold text-white text-2xl sm:text-3xl tracking-tight -mt-8 mb-4">
          Page not found
        </h1>
        <p className="text-slate-400 text-sm mb-10 max-w-md mx-auto">
          The page you are looking for does not exist or has been moved.
        </p>
        <Link
          to="/"
          data-testid="not-found-home-link"
          className="inline-flex items-center gap-2 bg-accent text-white font-semibold px-7 py-3.5 text-sm hover:bg-blue-500 transition-colors duration-300"
        >
          <ArrowLeft className="w-4 h-4" />
          Return to Homepage
        </Link>
      </div>
    </main>
  );
}
